// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { connect } from 'react-redux';
import InvoiceForm from '../../components/order/PayForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {orderAddItem, orderSetItem, orderGetItem,orderItemId,invoiceGetItem} from "../../actions/orderActions";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.order.getItem,
        invoiceInitialValues: state.order.invoiceGetItem,
        userValue : state.app.currentUser,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getOrderItem: (id) => {
        dispatch(getOrderItem(id));
    },
    setOrderId: (orderId) => {
        return(dispatch(orderItemId(orderId)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    }

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values) => {

    return (dispatch, getState) => {
        let orderId  = values.order._id
        let state = getState();

        let formData = {
            'cash': values.cash,
            'pos' : values.pos,
            'cheque': state.form.order.initial.cheque
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('order/cash/'+orderId, formData).then(res => {
            dispatch(orderAddItem(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/order/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getOrderItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('order/offline/'+id).then(orderInfo => {
            dispatch(orderGetItem(orderInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);
